import React from "react";

import AOS from "aos";
import "aos/dist/aos.css";

function Company() {
  return (
    <div className="container mx-auto">
      {/* <div className="flex flex-col gap-20 px-4 py-20 bg-gray-200 mt-72"> */}
      <div className="flex flex-col gap-40 px-4 pb-52 pt-28 mt-72">
        {/* section1 */}
        <section className="flex flex-col items-center justify-center px-24">
          <div className="flex text-4xl font-bold">
            <p className="text-main" >코끼리협동조합</p>
            <p className="text-gray-800">은?</p>
          </div>
          <div className="flex flex-col items-center w-full py-10 mt-10 text-white shadow-lg bg-gradient-to-b from-gradient1 to-gradient2 rounded-3xl" >
            <p className="mb-5 text-xl">
              Cooperative(협력하는) + 끼리끼리(우리)
            </p>
            <p className="text-lg">
              ‘코끼리’라는 이름은 ‘Cooperative’와 ‘끼리끼리’의 합성어입니다.
              <br />
              함께 고민하고 협력하는 코끼리는 언제나 사회 문제를 면밀히 마주하며
              <br />
              문제를 해소하기 위해 노력합니다.
            </p>
          </div>
        </section>
        {/* section2 */}
        {/* <section className="flex flex-col gap-10 bg-red-400"> */}
        <section className="flex flex-col gap-28">
          {/* 1 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 코끼리 메이커스페이스 운영
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “상상을 현실로 만드는 공간”
              </p>
              <p className="text-base leading-5 text-gray-600">
                <p>
                ‘코끼리 메이커스페이스’는 여러 분야의 장비와 장소를 멤버십 회원에게 제공합니다.
                </p>
                <p>
                디지털제작기기 · 목공 · 철공 · 유리공예 · 용접 ·
                후가공 · 페브릭 등 다양한 장비가 준비되어 있습니다.
                </p>
                <p>
                  초보자를 위한 장비 사용 교육 및 안전교육, 그리고 다양한 주제의 메이커 워크숍을 진행하고 있습니다.
                </p>
              </p>
            </div>
          </div>
          {/* 2 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 사회실험공간 여그 운영
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “지역 청년과 혁신가를 위한 든든한 실험공간”
              </p>
              <p className="text-base leading-5 text-gray-600">
                <p>
                ‘사회실험공간 여그’는 코워킹 스페이스로 광주광역시 북구 광주역 부근에 있습니다.
                </p>
                <p>
                  공유, 협업을 위한 공간으로, 프라이빗 오피스와 회의실, 강의실, 공용 주방과 레지던스를 갖추고 있습니다.
                </p>
                <p>
                  또한 지하에는 코끼리 메이커 스페이스가 있어 다양한 장비를 이용하여 프로젝트를 진행할 수 있습니다.
                </p>
              </p>
            </div>
          </div>
          {/* 3 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 일상 · 사회 문제
              <br />
              &nbsp;&nbsp;해결을 위한 연구
            </p>
            <div className="flex flex-col w-2/3 gap-3">
              <p className="text-xl font-semibold text-gray-600">
                “커뮤니티 비즈니스 커뮤니티 보유, 문제 해결을 위한 기술 제공”
              </p>
              <p className="text-base leading-5 text-gray-600">
                <p>
                  코끼리 협동조합은 수년간 구축한 지역 기반 네트워크를 통해 자체적으로 일상 문제를 인식하고
                  해결 방안을 모색합니다.
                </p>
                <p>
                  자체적인 기술이 부족한 예술가를 위한 기술 지원, 그리고 지역 소규모 숙박 업체를 위한 스마트 숙박 플랫폼 개발 등 기술 제공을 통해 일상·사회문제를 해결합니다.
                </p>
                 
              </p>
            </div>
          </div>
          {/* 4 */}
          <div className="flex w-full">
            <p className="w-1/3 text-2xl font-semibold text-gray-800">
              | 시제품 개발 및 제작
            </p>
            <div className="flex flex-col w-2/3 gap-3">
            <p className="text-xl font-semibold text-gray-600">
                “장비를 활용한 시제품 제작”
              </p>
              <p className="text-base leading-5 text-gray-600">
                <p>
                누구나 만들어보고 싶은 것이 있지만 재료 수급 및 장비의 부재로 인해 만들지 못하는 경우가 많습니다.
                코끼리 메이커 스페이스에는 3D 프린터, 디지털 제작 기구, 목공, 그리고 아두이노와 센서 등 다양한 장비를 보유하고 있습니다.
                장비는 모두 코끼리 메이커 스페이스에 있으니 아이디어와 열정만 있다면 누구나 시제품을 만들 수 있습니다.
                </p>
                <p>
                  　
                </p>
                <p>
                시제품 제작 경험이 없어서 내가 상상했던 제품을 만들 수 있을지 걱정되시나요?
                </p>
                <p>
                코끼리 협동조합의 다양한 분야의 기술자들이 함께 합니다.
                기존 메이커 활동 경험을 기반으로 시제품 제작 경험이 없으신 분들에게 시제품 개발 컨설팅을 제공합니다.
                </p>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

AOS.init();
export default Company;
